import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "order-tags order-tags__tags-edit-field"
}
const _hoisted_2 = { class: "order-tags__item" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "order-tags__content" }
const _hoisted_5 = {
  key: 1,
  class: "order-tags"
}
const _hoisted_6 = { class: "order-tags__item" }
const _hoisted_7 = { class: "order-tags__content" }
const _hoisted_8 = {
  key: 2,
  class: "order-tags"
}
const _hoisted_9 = { class: "order-tags__item" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "order-tags__content" }
const _hoisted_12 = {
  key: 3,
  class: "order-tags"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_shortkey = _resolveDirective("shortkey")!

  return ($setup.editing)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tags, (tag, i) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode($setup["Clipable"], {
              payload: tag,
              message: "Tag copied"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: "order-tags--remove t-icon",
                  onClick: _withModifiers(($event: any) => ($setup.removeTag(i)), ["stop"]),
                  "data-cy": "remove-order-tags"
                }, "j", 8, _hoisted_3),
                _createElementVNode("span", _hoisted_4, _toDisplayString(`#${tag}`), 1)
              ]),
              _: 2
            }, 1032, ["payload"])
          ]))
        }), 256)),
        _withDirectives(_createElementVNode("input", {
          class: "tag-input",
          autofocus: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.limitedInputValue) = $event)),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => ($setup.addTag($event.currentTarget.value)), ["enter"])),
          style: _normalizeStyle({width: $setup.inputWidth}),
          onShortkey: $setup.cancel
        }, null, 36), [
          [_vModelText, $setup.limitedInputValue],
          [_directive_shortkey, {esc: ['esc']}]
        ]),
        _withDirectives(_createElementVNode("div", { class: "error-meta meta" }, _toDisplayString($setup.error), 513), [
          [_vShow, $setup.error]
        ])
      ]))
    : ($setup.tags?.length && $props.summary)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString($setup.summaryString), 1)
          ], 512), [
            [_vShow, !$setup.editing]
          ])
        ]))
      : ($setup.tags?.length && !$props.summary)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tags, (tag, i) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode($setup["Clipable"], {
                  payload: tag,
                  message: "Tag copied"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "order-tags--remove t-icon",
                      onClick: _withModifiers(($event: any) => ($setup.removeTag(i)), ["stop"]),
                      "data-cy": "remove-order-tags"
                    }, "j", 8, _hoisted_10),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(`#${tag}`), 1)
                  ]),
                  _: 2
                }, 1032, ["payload"])
              ], 512)), [
                [_vShow, !$setup.editing]
              ])
            }), 256)),
            _withDirectives(_createElementVNode("button", {
              class: "filters__button tags_filter--add order-tags--add",
              "data-cy": "order-tags-btn",
              flat: "",
              dense: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleEdit(true)))
            }, "+", 512), [
              [_vShow, !$setup.editing]
            ])
          ]))
        : (!$props.summary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _withDirectives(_createElementVNode("button", {
                class: "filters__button tags_filter--add order-tags--add",
                "data-cy": "order-tags-btn",
                flat: "",
                dense: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleEdit(true)))
              }, "+ Tag", 512), [
                [_vShow, !$setup.editing]
              ])
            ]))
          : _createCommentVNode("", true)
}